import { AccordionContent, AccordionItem, AccordionTrigger, Spinner } from '@ibsys/kit';
import { FileCheck2Icon } from 'lucide-react';
import { FC } from 'react';
import { useExpertReport } from '@/entities/expert-report';
import { TreeBlockNode } from './TreeBlockNode';
import type { RuleWithPath } from './types';

type ReportSectionProps = {
  reportId: number;
  reportName: string;
  isExpanded: boolean;
  /** Условие отбора правил внутри заключения; пустое — заключение показывается целиком */
  contentSearch: string;
  linkedSet: Set<number>;
  selectedRules: Map<number, RuleWithPath>;
  onToggleRule: (rule: RuleWithPath) => void;
};

export const ReportSection: FC<ReportSectionProps> = ({
  reportId,
  reportName,
  isExpanded,
  contentSearch,
  linkedSet,
  selectedRules,
  onToggleRule,
}) => {
  const { data: reportDetail, isLoading } = useExpertReport(isExpanded ? reportId : undefined);

  return (
    <AccordionItem value={String(reportId)} className="border-0">
      <AccordionTrigger iconSide="left" className="px-2 py-1.5 hover:bg-muted/50 rounded-md">
        <div className="flex items-center gap-2">
          <FileCheck2Icon size={16} className="shrink-0 text-muted-foreground" />
          <span className="text-sm font-medium">{reportName}</span>
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-0 pb-0">
        {isLoading && (
          <div className="flex justify-center py-4">
            <Spinner className="size-5" />
          </div>
        )}
        {reportDetail?.blocks && (
          <div className="flex flex-col">
            {reportDetail.blocks
              .filter((b) => !b.isDeleted)
              .map((block) => (
                <TreeBlockNode
                  key={block.id}
                  block={block}
                  reportId={reportId}
                  reportName={reportName}
                  depth={0}
                  blockPath={[]}
                  search={contentSearch}
                  linkedSet={linkedSet}
                  selectedRules={selectedRules}
                  onToggleRule={onToggleRule}
                />
              ))}
          </div>
        )}
      </AccordionContent>
    </AccordionItem>
  );
};
